import React, {useCallback, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './PolicyLiabilityComponent.metadata.json5';
import styles from "./PolicyLiabilityComponent.module.scss";
import CoveragesComponent from './../CoveragesComponent/CoveragesComponent';

/* const getLimitDeductible = (items,property) => {
    let amount = "-";
   if (items.terms.length > 0) {
    items.terms.forEach(function(term) {
        if (term?.modelType?.toUpperCase() === property.toUpperCase() ||
            term?.name?.toUpperCase() === property.toUpperCase()) {
            amount = term.amount;
        }
    });
    }
   return amount;
};

const getCellCoverageName = (rowData) => {
    return (
        <span>
            {rowData.name}
        </span>
    );
};

const getCellCoverageLimit = (rowData) => {
    if  (_.isEmpty(rowData.limit)) {
    return (
        <span>
            {getLimitDeductible(rowData,'Limit')}
        </span>
    );}
    else {
 return (
        <span>
            {rowData.limit}
        </span>
    );}
};

const getCellCoverageDeductible = (rowData) => {
 if  (_.isEmpty(rowData.deductible)) {
     return (
        <span>
            {getLimitDeductible(rowData,'Deductible')}
        </span>
    );
}
else {
return (
        <span>
            {rowData.deductible}
        </span>
    );
}
}; */

const getCellLiabilityExtensionName = (rowData) => {
    return (
        <span>
            {rowData.name}
        </span>
    );
};

const getCellLiabilityUnderWritingClassesName = (rowData) => {
    return (
        <span>
            {rowData.name}
        </span>
    );
};


function PolicyLiabilityComponent(props) {
    const { value: currentPeriodDetails } = props;
    if (_.isEmpty(currentPeriodDetails) || currentPeriodDetails === undefined) {
        return null;
    }

    const getLobData = (currentDetails) => {
        const { productName } = currentDetails;
        let lData = '';
        // eslint-disable-next-line default-case
        switch (productName) {
            case 'Commercial Property':
                lData = currentDetails.lobs.commercialProperty;
                break;
            case 'Residential':
                lData = currentDetails.lobs.homeOwners;
                break;
			case 'Farm':
                lData = currentDetails.lobs.homeOwners;
                break;
			case 'Marine':
                lData = currentDetails.lobs.homeOwners;
                break;
            }
        return lData;
    };

    const lobData = getLobData(currentPeriodDetails);

    const policyLiabilityCoverables = useMemo(() => {
        return lobData.liabilityCoverageDTOs;
    }, [currentPeriodDetails]);

    const policyLiabilityExtensions = useMemo(() => {
        const liabilityCoverages = lobData.liabilityExtensions;
        const liabilityExtensions = [];
        if (liabilityCoverages) {
            liabilityCoverages.forEach((coverage) => {
                if (coverage.riskExposure === false) {
                    liabilityExtensions.push(coverage);
                }
            });
         }
        return liabilityExtensions;
    }, [lobData]);

    const policyLiabilityUnderWritingClasses = useMemo(() => {
        const liabilityCoverages = lobData.liabilityExtensions;
        const liabilityUW = [];
        if (liabilityCoverages) {
            liabilityCoverages.forEach((coverage) => {
                if (coverage.riskExposure === true) {
                    liabilityUW.push(coverage);
                }
            });
        }
        return liabilityUW;
    }, [lobData]);

    /* const generateLiabilityTableOverrides = useCallback(() => {
        return {
             coverageColumn: { onCell: getCellCoverageName },
             limitColumn: { onCell: getCellCoverageLimit },
             deductibleColumn: { onCell: getCellCoverageDeductible }
        };
    }, [policyLiabilityCoverables]); */

    const generateLiabilityExtensionsTableOverrides = useCallback(() => {
        return {
            liabilityExtensionsColumn: { onCell: getCellLiabilityExtensionName }
        };
    }, [policyLiabilityExtensions]);

    const overrides = {
        PolicyLiability: {
            //data: lobData,
            visible: !_.isEmpty(policyLiabilityCoverables)
        },
        liabilityCoverageSection: {
            value: policyLiabilityCoverables,
            visible: !_.isEmpty(policyLiabilityCoverables)
        },
        PolicyLiabilityExtensions: {
            visible: !_.isEmpty(policyLiabilityExtensions)
        },
        policyLiabilityExtensionsTable: {
            data: policyLiabilityExtensions,
            visible: !_.isEmpty(policyLiabilityExtensions)
        },
        PolicyLiabilityUwClasses:{
            visible: !_.isEmpty(policyLiabilityUnderWritingClasses)
        },
        policyLiabilityUwClassesTable: {
            data: policyLiabilityUnderWritingClasses,
            visible: !_.isEmpty(policyLiabilityUnderWritingClasses)
        },
        liabilityUnderWritingClassesColumn: {
            onCell: getCellLiabilityUnderWritingClassesName
        },
        noLiabilityLabel: {
            visible: _.isEmpty(policyLiabilityUnderWritingClasses) && _.isEmpty(policyLiabilityExtensions) && _.isEmpty(policyLiabilityCoverables)
        },
        marineLiabilityNote: {
            visible: currentPeriodDetails.productName === 'Marine' && !(_.isEmpty(policyLiabilityCoverables))
        },
        //...generateLiabilityTableOverrides(),
        ...generateLiabilityExtensionsTableOverrides()
    };

    const resolvers = {
        resolveComponentMap: {
            coveragescomponent: CoveragesComponent
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={lobData}
            overrideProps={overrides}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={styles}
        />
    );
}


PolicyLiabilityComponent.propTypes = {
    value: PropTypes.shape({})
};

PolicyLiabilityComponent.defaultProps = {
    value: {
        // lobData: {},
        // liabilityCoverageDTOs: [],
        // liabilityExtensions: []
    }
};

export default PolicyLiabilityComponent;
